// extracted by mini-css-extract-plugin
export default {"summary":"MealsSummary_summary__MW+lC","a":"MealsSummary_a__RwSa5"};